import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem("heda_user");
    return u ? JSON.parse(u) : null;
  });
  const [loading, setLoading] = useState(false);

  // Self-heal: if we have a token but role is missing (legacy session), fetch /auth/me
  useEffect(() => {
    const token = localStorage.getItem("heda_token");
    if (!token) return;
    if (user && user.role) return;
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        const next = {
          email: data.email,
          name: user?.name || data.email,
          role: data.role || "owner",
        };
        localStorage.setItem("heda_user", JSON.stringify(next));
        setUser(next);
      } catch {
        // token invalid, leave as-is
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("heda_token", data.token);
      const u = { email: data.email, name: data.name, role: data.role };
      localStorage.setItem("heda_user", JSON.stringify(u));
      setUser(u);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e?.response?.data?.detail || "Login failed" };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("heda_token");
    localStorage.removeItem("heda_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
